/**
 * Mamash Organics — Header JS
 * Handles: scroll-blur effect, mobile menu toggle, wishlist badge count
 */

(function () {
  'use strict';

  const header = document.getElementById('mamash-header');
  const menuToggle = document.getElementById('mamash-menu-toggle');
  const mobileMenu = document.getElementById('mamash-mobile-menu');
  const iconMenu = document.getElementById('mamash-icon-menu');
  const iconClose = document.getElementById('mamash-icon-close');

  // ── Scroll blur effect ──────────────────────────────────────────────────────
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 20) {
        header.classList.add('bg-background/95', 'backdrop-blur-md', 'shadow-sm');
        header.classList.remove('bg-background');
      } else {
        header.classList.remove('bg-background/95', 'backdrop-blur-md', 'shadow-sm');
        header.classList.add('bg-background');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ── Mobile menu toggle ──────────────────────────────────────────────────────
  if (menuToggle && mobileMenu) {
    let isOpen = false;

    const openMenu = () => {
      isOpen = true;
      mobileMenu.style.maxHeight = mobileMenu.scrollHeight + 'px';
      mobileMenu.style.opacity = '1';
      mobileMenu.setAttribute('aria-hidden', 'false');
      menuToggle.setAttribute('aria-expanded', 'true');
      menuToggle.setAttribute('aria-label', 'Close menu');
      if (iconMenu) iconMenu.style.display = 'none';
      if (iconClose) iconClose.style.display = '';
    };

    const closeMenu = () => {
      isOpen = false;
      mobileMenu.style.maxHeight = '0';
      mobileMenu.style.opacity = '0';
      mobileMenu.setAttribute('aria-hidden', 'true');
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Open menu');
      if (iconMenu) iconMenu.style.display = '';
      if (iconClose) iconClose.style.display = 'none';
    };

    menuToggle.addEventListener('click', () => {
      isOpen ? closeMenu() : openMenu();
    });

    // Close when a nav link is clicked
    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) closeMenu();
    });
  }

  // ── Wishlist badge count (reads localStorage) ───────────────────────────────
  const updateWishlistBadge = () => {
    const badge = document.getElementById('mamash-wishlist-count');
    if (!badge) return;
    try {
      const items = JSON.parse(localStorage.getItem('mamash_wishlist_v1') || '[]');
      const count = Array.isArray(items) ? items.length : 0;
      if (count > 0) {
        badge.textContent = count > 99 ? '99+' : count;
        badge.classList.remove('hidden');
      } else {
        badge.classList.add('hidden');
      }
    } catch (_) {
      badge.classList.add('hidden');
    }
  };

  updateWishlistBadge();

  // Re-check badge when other tabs update localStorage
  window.addEventListener('storage', (e) => {
    if (e.key === 'mamash_wishlist_v1') updateWishlistBadge();
  });

  // ── Cart count update after AJAX operations ─────────────────────────────────
  // Dawn fires a 'cart:refresh' custom event after any cart mutation.
  // We update the badge by re-reading the section HTML Dawn injects.
  document.addEventListener('cart:refresh', () => {
    fetch(`${window.location.origin}/cart.js`)
      .then((r) => r.json())
      .then((cart) => {
        const badge = document.getElementById('mamash-cart-count');
        if (!badge) return;
        const count = cart.item_count || 0;
        if (count > 0) {
          badge.textContent = count > 99 ? '99+' : count;
          badge.classList.remove('hidden');
        } else {
          badge.classList.add('hidden');
        }
      })
      .catch(() => {});
  });
})();
